import { ChartBuilder } from 'Molecules/InsightsChart/chartBuilder';
import { ChartType } from '../chartTypes';
import { DonutChartData } from 'Molecules/InsightsChart/chartBuilder';
import { BaseInsightPayload } from '../InsightDataPayload';
import { InsightChartFactory } from '../insightChartFactory';
import { parseCapacityManagementUserTypePayload } from '../payloads/capacityManagementUserTypePayload';

import DefaultChartWithTrendSupport from 'Molecules/InsightsChart/DefaultChartWithTrendSupport';
export const buildCapacityManagementUserTypeInsightFactory = (
  payload: BaseInsightPayload
): InsightChartFactory => {
  const parsedPayload = parseCapacityManagementUserTypePayload(payload);
  const data = parsedPayload.data.attributes.data;

  return (props) => {
    const chart = new ChartBuilder()
      .setChartType(ChartType.DONUT)
      .setProps({
        chartData: data as DonutChartData,
        onDrillDown: props.onDrillDown,
        valueFieldName: 'user_count',
        categoryFieldName: 'user_type',
      })
      .build();

    return DefaultChartWithTrendSupport({
      chartComponent: chart,
    });
  };
};
